import { defineMessages } from 'react-intl';

const translations = {
  create: {
    button: {
      id: 'pages.couponCategoryView.create.button',
      defaultMessage: 'New coupon code',
      description: 'title of the create coupon code button',
    },
  },
  actions: {
    quickAdd: {
      id: 'pages.couponCategoryView.actions.quickAdd',
      defaultMessage: 'Quick add',
      description: 'title of the create coupon code button',
    },
    customAdd: {
      id: 'pages.couponCategoryView.actions.customAdd',
      defaultMessage: 'Add custom code',
      description: 'title of the create coupon code button',
    },
  },
  breadcrumbs: {
    coupons: {
      id: 'pages.couponCategoryView.breadcrumbs.coupons',
      defaultMessage: 'Coupons',
      description: 'label of the coupons breadcrumb',
    },
  },
  createCoupon: {
    title: {
      id: 'pages.couponCategoryView.createCoupon.title',
      defaultMessage: 'Create new coupon',
      description: 'title of the create new coupon drawer',
    },
  },
  previewActions: {
    disableCouponCode: {
      id: 'pages.couponCategoryView.previewActions.disableCouponCode',
      defaultMessage: 'Disable coupon code',
      description: 'label of the disable coupon code action',
    },
  },
  viewCoupon: {
    title: {
      id: 'pages.couponCategoryView.viewCoupon.title',
      defaultMessage: 'Coupon code',
      description: 'title of the coupon view drawer',
    },
  },
  feedback: {
    couponCreated: {
      id: 'pages.couponCategoryView.feedback.couponCreated',
      defaultMessage: 'Coupon created',
      description: 'notification on the successful creation of a coupon',
    },
    couponNotCreated: {
      id: 'pages.couponCategoryView.feedback.couponNotCreated',
      defaultMessage: 'Coupon code could not be created',
      description: 'notification on the failed creation of a coupon',
    },
    couponDisabled: {
      id: 'pages.couponCategoryView.feedback.couponDisabled',
      defaultMessage: 'Coupon code disabled',
      description: 'notification on the successful disabling of a coupon',
    },
    couponNotDisabled: {
      id: 'pages.couponCategoryView.feedback.couponNotDisabled',
      defaultMessage: 'Coupon could not be disabled',
      description: 'notification on the failed disabling of a coupon',
    },
  },
};

export default defineMessages(translations);
